<template lang='pug' >
	.headerImageShort
		.contenedor-headerImageShort
			.contenido
				.modulo.modulo-1
					h2.caja-texto1
						| Prepare your Title 24 Report Yourself!
					app-link.btn(:to="navLinks.newProject")
						span
							| Create project
</template>

<script>
export default {
	name: 'headerInterior',
	data: function () {
		return {
			navLinks: {}
		}
	},
	beforeMount: function () {
		this.navLinks = this.$e24Common.storageService.findItem('navLinks', true)
		// console.debug('NavBar config', this.navLinks)
	}
}
</script>



// WEBPACK FOOTER //
// src/components/doit/HeaderInterior.vue